import { useQuery } from '@tanstack/react-query'
import { fetchDistrictsByRegion } from '@/services/districts'

export function useDistrictsByRegion(regionId: string | undefined) {
  const districtsQuery = useQuery({
    queryKey: ['districts', 'region', regionId],
    queryFn: () => fetchDistrictsByRegion(regionId!),
    enabled: !!regionId,
  })

  return {
    districts: districtsQuery.data,
    isLoading: districtsQuery.isLoading,
    error: districtsQuery.error,
  }
}
